module.exports = __webpack_public_path__ + "static/img/4.191b767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/4.png
// module id = v9AX
// module chunks = 0